import { render, staticRenderFns } from "./CardBadge.vue?vue&type=template&id=7e6e19ab&scoped=true&"
import script from "./CardBadge.vue?vue&type=script&lang=js&"
export * from "./CardBadge.vue?vue&type=script&lang=js&"
import style0 from "./CardBadge.vue?vue&type=style&index=0&id=7e6e19ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6e19ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
